import { Outlet, useNavigate } from 'react-router-dom'
import useStore from '@/store/store'
import { toast } from 'sonner'
import { Suspense, useEffect } from 'react'
import { Skeleton } from '@/components/UI/Skeleton'

const AuthGuard = () => {
  const { token } = useStore.getState()
  const navigate = useNavigate()
  // const navigation = useNavigation()
  
  // const isNavigating = navigation.state === 'loading' && navigation.location.pathname === '/'

  useEffect(() => {
    if (!token) {
      // 未登录则显示错误消息
      toast.error('登录失效，请重新登录')
      // 登录失效后重定向到登录页（如需要可解注释）
      navigate('/login', { replace: true })
    }
  }, [token])

  // 全局 loading 状态
  // if (isNavigating) {
  //   return (
  //     <div className='h-screen w-full flex flex-col gap-4 p-6 bg-surface'>
  //       <Skeleton className='h-12 w-full' />
  //       <Skeleton className='h-64 w-full' />
  //       <Skeleton className='h-64 w-full' />
  //     </div>
  //   )
  // }

  // 已登录则渲染子路由
  return (
  <Suspense fallback={
    <div className='h-screen w-full flex flex-col gap-4 p-6 bg-surface'>
        <Skeleton className='h-12 w-full' />
        <Skeleton className='h-64 w-full' />
        <Skeleton className='h-64 w-full' />
      </div>
  }>
    <Outlet />
  </Suspense>
  )
}

export default AuthGuard
